// Projects data for the portfolio
export const projects = [
  {
    id: 'pocketfiler',
    title: 'PocketFiler',
    category: 'Document Management System (DMS)',
    description: 'A comprehensive document management system designed for efficient file organization, storage, and retrieval. Built with enterprise-grade security and seamless collaboration features.',
    fullDescription: `PocketFiler is an advanced Document Management System (DMS) that revolutionizes how businesses handle their digital documentation. The platform offers intuitive file organization, powerful search capabilities, and robust security measures.

Key features include automatic document categorization, version control, and multi-user collaboration tools. The system integrates seamlessly with existing workflows and provides detailed audit trails for compliance requirements.`,
    image: 'https://customer-assets.emergentagent.com/job_frontend-wow/artifacts/u74mjn3m_PocketFiler1.png',
    tags: ['Web App', 'Enterprise', 'DMS'],
    platform: 'Web Application',
    industry: 'Enterprise Software',
    services: ['UI/UX Design', 'Web Development', 'Cloud Integration'],
    year: '2024',
    featured: true
  },
  {
    id: 'pk-page',
    title: 'PK.Page',
    category: 'Digital Marketing Agency',
    description: 'A sleek and modern website for a digital marketing agency, showcasing their services and portfolio with stunning visuals and smooth animations.',
    fullDescription: `PK.Page is a cutting-edge digital marketing agency website designed to captivate and convert visitors. The site features bold typography, dynamic animations, and a modern dark theme that reflects the agency's innovative approach.

The website includes comprehensive service pages, case studies, team profiles, and an integrated blog. Custom animations and micro-interactions create an engaging user experience that sets the agency apart from competitors.`,
    image: 'https://customer-assets.emergentagent.com/job_frontend-wow/artifacts/evnt6e9r__pk.page.png',
    tags: ['Marketing', 'Website', 'Agency'],
    platform: 'Website',
    industry: 'Digital Marketing',
    services: ['Branding', 'Web Design', 'Development'],
    year: '2024',
    featured: true
  },
  {
    id: 'gaya-blockchain',
    title: 'Gaya Blockchain',
    category: 'Layer 1 Blockchain',
    description: 'A next-generation Layer 1 blockchain platform designed for scalability, security, and decentralized applications.',
    fullDescription: `Gaya Blockchain is a revolutionary Layer 1 blockchain infrastructure built from the ground up to address the limitations of existing blockchain networks. The platform offers unprecedented transaction speeds, low fees, and robust smart contract capabilities.

The ecosystem includes a native cryptocurrency, developer tools, and comprehensive documentation for building decentralized applications. Advanced consensus mechanisms ensure network security while maintaining environmental sustainability.`,
    image: 'https://customer-assets.emergentagent.com/job_frontend-wow/artifacts/1xs2a3t4_gaya%20blockchain.png',
    tags: ['Web3', 'Blockchain', 'Layer 1'],
    platform: 'Blockchain Platform',
    industry: 'Cryptocurrency',
    services: ['Blockchain Development', 'Smart Contracts', 'Web3 Integration'],
    year: '2024',
    featured: true
  },
  {
    id: 'evox-network',
    title: 'Evox Network',
    category: 'RWA Tokenization Platform',
    description: 'A comprehensive platform for tokenizing real-world assets, enabling fractional ownership and global investment opportunities.',
    fullDescription: `Evox Network is a pioneering Real World Asset (RWA) tokenization platform that bridges traditional finance with blockchain technology. The platform enables businesses and individuals to tokenize physical assets, creating new investment opportunities.

Features include regulatory compliance tools, fractional ownership mechanisms, and secondary market trading. The platform supports various asset classes including real estate, commodities, and collectibles.`,
    image: 'https://customer-assets.emergentagent.com/job_frontend-wow/artifacts/0wlud7wf__evox.png',
    tags: ['Web3', 'Tokenization', 'RWA'],
    platform: 'Web Platform',
    industry: 'Fintech',
    services: ['Blockchain Development', 'Platform Development', 'Compliance Integration'],
    year: '2024',
    featured: true
  },
  {
    id: 'hft-mini-app',
    title: 'HFT Mini App',
    category: 'Telegram Mini App',
    description: 'A high-frequency trading mini application built for Telegram, enabling users to trade cryptocurrencies directly within the messaging platform.',
    fullDescription: `HFT Mini App is an innovative Telegram-based trading application that brings sophisticated trading capabilities to mobile users. The app features real-time market data, instant order execution, and portfolio management tools.

Built on the Telegram Mini Apps platform, users can trade without leaving their favorite messaging app. Advanced features include price alerts, automated trading strategies, and social trading capabilities.`,
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800',
    tags: ['Telegram', 'Trading', 'Crypto'],
    platform: 'Telegram Mini App',
    industry: 'Fintech',
    services: ['Bot Development', 'Trading Integration', 'UI/UX Design'],
    year: '2024',
    featured: false
  },
  {
    id: 'raid-ai',
    title: 'Raid AI',
    category: 'AI-Powered Platform',
    description: 'An artificial intelligence platform that leverages machine learning to provide intelligent insights and automation capabilities.',
    fullDescription: `Raid AI is a cutting-edge artificial intelligence platform designed to transform business operations through intelligent automation. The platform combines multiple AI technologies including natural language processing, computer vision, and predictive analytics.

Key applications include customer service automation, data analysis, content generation, and process optimization. The platform is designed to scale with business needs and integrate seamlessly with existing systems.`,
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800',
    tags: ['AI', 'Machine Learning', 'Automation'],
    platform: 'Web Platform',
    industry: 'Technology',
    services: ['AI Development', 'Platform Development', 'Integration'],
    year: '2024',
    featured: false
  },
  {
    id: 'lego-ramadan',
    title: 'Lego Ramadan',
    category: 'Interactive Campaign',
    description: 'A creative digital campaign combining Lego and Ramadan themes with interactive web experiences and engaging animations.',
    fullDescription: `Lego Ramadan is an innovative digital marketing campaign that celebrates the holy month of Ramadan through interactive Lego-themed experiences. The project combines cultural celebration with playful digital engagement.

Features include interactive games, shareable content, and community challenges. The campaign successfully bridged brand engagement with cultural sensitivity, creating meaningful connections with the target audience.`,
    image: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=800',
    tags: ['Campaign', 'Interactive', 'Marketing'],
    platform: 'Web Campaign',
    industry: 'Marketing',
    services: ['Creative Design', 'Web Development', 'Campaign Strategy'],
    year: '2024',
    featured: false
  },
  {
    id: 'davince-ai',
    title: 'Davince AI',
    category: 'AI Creative Platform',
    description: 'A creative AI platform that assists artists and designers with intelligent tools for image generation and editing.',
    fullDescription: `Davince AI is a revolutionary creative platform that empowers artists and designers with AI-powered tools. The platform offers advanced image generation, style transfer, and intelligent editing capabilities.

Features include text-to-image generation, image upscaling, background removal, and collaborative workspaces. The platform is designed to enhance creative workflows while maintaining artistic control.`,
    image: 'https://images.unsplash.com/photo-1547954575-855750c57bd3?w=800',
    tags: ['AI', 'Creative', 'Design Tools'],
    platform: 'Web Application',
    industry: 'Creative Technology',
    services: ['AI Development', 'UI/UX Design', 'Platform Development'],
    year: '2024',
    featured: false
  },
  {
    id: 'web3fund',
    title: 'Web3Fund',
    category: 'DeFi Investment Platform',
    description: 'A decentralized finance platform enabling users to invest in and manage crypto portfolios with advanced analytics.',
    fullDescription: `Web3Fund is a comprehensive DeFi investment platform that democratizes access to cryptocurrency investments. The platform offers portfolio management, yield optimization, and risk analysis tools.

Key features include automated portfolio rebalancing, staking rewards aggregation, and cross-chain asset management. The platform prioritizes security with multi-signature wallets and smart contract audits.`,
    image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800',
    tags: ['DeFi', 'Investment', 'Web3'],
    platform: 'Web Application',
    industry: 'Fintech',
    services: ['Smart Contract Development', 'Platform Development', 'Security Audit'],
    year: '2024',
    featured: false
  },
  {
    id: 'gaya-wallet-extension',
    title: 'Gaya Wallet Extension',
    category: 'Browser Extension Wallet',
    description: 'A secure browser extension wallet for managing digital assets on the Gaya blockchain ecosystem.',
    fullDescription: `Gaya Wallet Extension is a feature-rich browser wallet designed for seamless interaction with the Gaya blockchain. The extension provides secure key management, transaction signing, and dApp connectivity.

Features include multi-account support, hardware wallet integration, and customizable gas settings. The wallet prioritizes user experience with an intuitive interface while maintaining enterprise-grade security.`,
    image: 'https://images.unsplash.com/photo-1622630998477-20aa696ecb05?w=800',
    tags: ['Wallet', 'Browser Extension', 'Web3'],
    platform: 'Browser Extension',
    industry: 'Cryptocurrency',
    services: ['Extension Development', 'Security Implementation', 'UI/UX Design'],
    year: '2024',
    featured: false
  },
  {
    id: 'utopia',
    title: 'Utopia',
    category: 'Metaverse Platform',
    description: 'An immersive metaverse experience combining virtual reality, social interaction, and digital commerce.',
    fullDescription: `Utopia is a next-generation metaverse platform that creates immersive virtual experiences for users worldwide. The platform combines social networking, gaming, and digital commerce in a seamless virtual environment.

Features include customizable avatars, virtual real estate, NFT integration, and live events. The platform supports both VR headsets and standard web browsers, ensuring accessibility for all users.`,
    image: 'https://images.unsplash.com/photo-1617802690992-15d93263d3a9?w=800',
    tags: ['Metaverse', 'VR', 'Social'],
    platform: 'Web & VR',
    industry: 'Entertainment',
    services: ['3D Development', 'Platform Development', 'Blockchain Integration'],
    year: '2024',
    featured: false
  },
  {
    id: 'gaya-testnet',
    title: 'Gaya Testnet',
    category: 'Blockchain Testing Platform',
    description: 'A comprehensive testnet environment for developers to build and test applications on the Gaya blockchain.',
    fullDescription: `Gaya Testnet is a robust development environment that mirrors the mainnet functionality while providing free testing capabilities. The platform includes faucets, block explorers, and developer documentation.

Features include automated testing tools, smart contract debugging, and performance monitoring. The testnet ensures developers can thoroughly validate their applications before mainnet deployment.`,
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800',
    tags: ['Blockchain', 'Development', 'Testing'],
    platform: 'Blockchain Network',
    industry: 'Cryptocurrency',
    services: ['Infrastructure Development', 'Developer Tools', 'Documentation'],
    year: '2024',
    featured: false
  },
  {
    id: 'gaya-website',
    title: 'Gaya Website',
    category: 'Corporate Blockchain Website',
    description: 'The official website for Gaya blockchain, showcasing the ecosystem, technology, and community resources.',
    fullDescription: `The Gaya Website serves as the central hub for the Gaya blockchain ecosystem. The site features comprehensive information about the technology, team, roadmap, and community initiatives.

The website includes interactive elements, real-time network statistics, and seamless integration with ecosystem products. Designed for both technical and non-technical audiences, it effectively communicates the project's vision.`,
    image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?w=800',
    tags: ['Website', 'Blockchain', 'Corporate'],
    platform: 'Website',
    industry: 'Cryptocurrency',
    services: ['Web Design', 'Development', 'Content Strategy'],
    year: '2024',
    featured: false
  },
  {
    id: 'gaya-wallet-website',
    title: 'Gaya Wallet Website',
    category: 'Product Landing Page',
    description: 'A modern landing page for the Gaya Wallet, highlighting features, security, and download options.',
    fullDescription: `The Gaya Wallet Website is a conversion-optimized landing page designed to drive wallet downloads and user adoption. The site showcases wallet features, security measures, and supported platforms.

Features include animated demonstrations, comparison tables, and comprehensive FAQ sections. The site integrates analytics and A/B testing to continuously optimize conversion rates.`,
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800',
    tags: ['Landing Page', 'Wallet', 'Web3'],
    platform: 'Website',
    industry: 'Cryptocurrency',
    services: ['Landing Page Design', 'Development', 'Conversion Optimization'],
    year: '2024',
    featured: false
  },
  {
    id: 'dr3',
    title: 'DR3',
    category: 'Web3 Gaming Platform',
    description: 'A decentralized gaming platform featuring play-to-earn mechanics and NFT integration.',
    fullDescription: `DR3 is an innovative Web3 gaming platform that combines traditional gaming with blockchain technology. The platform offers play-to-earn games, NFT marketplaces, and community tournaments.

Features include cross-game asset portability, transparent reward distributions, and governance participation. The platform supports multiple games with unified wallet integration and social features.`,
    image: 'https://images.unsplash.com/photo-1614680376593-902f74cf0d41?w=800',
    tags: ['Gaming', 'Web3', 'NFT'],
    platform: 'Web Platform',
    industry: 'Gaming',
    services: ['Game Development', 'Blockchain Integration', 'NFT Development'],
    year: '2024',
    featured: false
  },
  {
    id: 'city-crafters',
    title: 'City Crafters',
    category: 'Urban Planning Simulation',
    description: 'An engaging city-building simulation game that teaches urban planning principles through interactive gameplay.',
    fullDescription: `City Crafters is an educational city-building game that makes urban planning accessible and fun. Players design and manage virtual cities while learning about sustainable development, resource management, and civic planning.

The game features realistic simulations, challenges based on real-world scenarios, and multiplayer collaboration modes. Educational institutions use the platform to teach geography, economics, and environmental science.`,
    image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800',
    tags: ['Gaming', 'Education', 'Simulation'],
    platform: 'Web & Mobile',
    industry: 'Education',
    services: ['Game Development', 'UI/UX Design', 'Educational Content'],
    year: '2024',
    featured: false
  },
  {
    id: 'atherix',
    title: 'Atherix',
    category: 'Healthcare Technology Platform',
    description: 'A comprehensive healthcare technology solution connecting patients with providers through intelligent matching.',
    fullDescription: `Atherix is a healthcare technology platform that revolutionizes patient-provider connections. The platform uses AI-powered matching algorithms to connect patients with the most suitable healthcare providers.

Features include telemedicine integration, appointment scheduling, health records management, and insurance verification. The platform prioritizes data security and HIPAA compliance while maintaining ease of use.`,
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800',
    tags: ['Healthcare', 'Platform', 'AI'],
    platform: 'Web & Mobile',
    industry: 'Healthcare',
    services: ['Platform Development', 'AI Integration', 'Security Implementation'],
    year: '2024',
    featured: false
  },
  {
    id: 'legion-mini-app',
    title: 'Legion Mini App',
    category: 'Telegram Gaming Bot',
    description: 'A multiplayer gaming experience built as a Telegram mini app with social features and rewards.',
    fullDescription: `Legion Mini App is an engaging multiplayer game designed for the Telegram platform. The app offers competitive gameplay, social features, and reward mechanisms that keep players engaged.

Features include real-time multiplayer matches, leaderboards, achievement systems, and in-app rewards. The game leverages Telegram's social features to enable easy sharing and friend invitations.`,
    image: 'https://images.unsplash.com/photo-1552820728-8b83bb6b2b0b?w=800',
    tags: ['Telegram', 'Gaming', 'Social'],
    platform: 'Telegram Mini App',
    industry: 'Gaming',
    services: ['Game Development', 'Bot Development', 'Social Integration'],
    year: '2024',
    featured: false
  },
  {
    id: 'magnus-mini-app',
    title: 'Magnus Mini App',
    category: 'Productivity Telegram Bot',
    description: 'A productivity-focused Telegram mini app helping users manage tasks, schedules, and team collaboration.',
    fullDescription: `Magnus Mini App is a powerful productivity tool built for Telegram users who want to stay organized without leaving their favorite messaging app. The app offers task management, calendar integration, and team coordination features.

Features include smart reminders, recurring tasks, project templates, and team workspaces. The app syncs across devices and integrates with popular productivity tools.`,
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800',
    tags: ['Telegram', 'Productivity', 'Tools'],
    platform: 'Telegram Mini App',
    industry: 'Productivity',
    services: ['Bot Development', 'UI/UX Design', 'Integration Development'],
    year: '2024',
    featured: false
  },
  {
    id: 'swipe-arena',
    title: 'Swipe Arena',
    category: 'Telegram Gaming Platform',
    description: 'A fast-paced swipe-based gaming platform on Telegram with competitive tournaments and prizes.',
    fullDescription: `Swipe Arena is an addictive gaming platform built for Telegram that turns simple swipe gestures into competitive gameplay. The platform hosts daily tournaments with real prizes and maintains active leaderboards.

Features include multiple game modes, skill-based matchmaking, social challenges, and reward pools. The platform uses blockchain technology for transparent prize distribution and verifiable game outcomes.`,
    image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800',
    tags: ['Telegram', 'Gaming', 'Tournament'],
    platform: 'Telegram Mini App',
    industry: 'Gaming',
    services: ['Game Development', 'Blockchain Integration', 'Tournament Systems'],
    year: '2024',
    featured: false
  },
  {
    id: 'natrium',
    title: 'Natrium',
    category: 'Mobile Crypto Wallet',
    description: 'A fast and secure mobile wallet for managing cryptocurrency with an emphasis on user experience.',
    fullDescription: `Natrium is a beautifully designed mobile cryptocurrency wallet that prioritizes speed, security, and user experience. The wallet supports multiple cryptocurrencies and provides instant transaction confirmations.

Features include biometric authentication, QR code payments, address book management, and transaction history analytics. The wallet is available on both iOS and Android with synchronized cloud backup.`,
    image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=800',
    tags: ['Mobile', 'Wallet', 'Crypto'],
    platform: 'iOS & Android',
    industry: 'Cryptocurrency',
    services: ['Mobile Development', 'Security Implementation', 'UI/UX Design'],
    year: '2024',
    featured: false
  },
  {
    id: 'appstudiopro',
    title: 'App Studio Pro',
    category: 'Company Website',
    description: 'Our own company website showcasing our services, portfolio, and commitment to excellence in software development.',
    fullDescription: `App Studio Pro is our flagship company website, designed to showcase our capabilities and attract potential clients. The site features a modern dark theme with vibrant accent colors and smooth animations.

The website includes comprehensive service pages, detailed portfolio items, team profiles, and an integrated contact system. Custom animations and micro-interactions create an engaging experience that reflects our technical expertise.`,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
    tags: ['Website', 'Agency', 'Portfolio'],
    platform: 'Website',
    industry: 'Technology',
    services: ['Web Design', 'Development', 'Branding'],
    year: '2024',
    featured: true
  }
];

// Get featured projects
export const getFeaturedProjects = () => projects.filter(p => p.featured);

// Get project by ID
export const getProjectById = (id) => projects.find(p => p.id === id);

// Get projects by tag
export const getProjectsByTag = (tag) => projects.filter(p => p.tags.includes(tag));

// Get all unique tags
export const getAllTags = () => {
  const tags = new Set();
  projects.forEach(p => p.tags.forEach(t => tags.add(t)));
  return Array.from(tags).sort();
};

// Get projects by industry
export const getProjectsByIndustry = (industry) => projects.filter(p => p.industry === industry);

// Get all unique industries
export const getAllIndustries = () => {
  const industries = new Set();
  projects.forEach(p => industries.add(p.industry));
  return Array.from(industries).sort();
};

export default projects;
